"use client";

import { dynamicChart } from "@/components/charts/dynamicChart";

export type { IndoorOutdoorRow } from "./IndoorOutdoorChart.impl";

export const IndoorOutdoorChart = dynamicChart(
  () => import("./IndoorOutdoorChart.impl").then((m) => m.IndoorOutdoorChart),
  288,
);
